import type { AxiosInstance } from 'axios';
import baseAxios from 'axios';
import qs from 'query-string';

interface ChatbotAxios extends AxiosInstance {
  setToken?: (token: string) => void;
}

declare global {
  interface Window {
    REACT_APP_CHATBOT_API_HOST: string;
  }
}

export const baseURL =
  window.REACT_APP_CHATBOT_API_HOST ||
  process.env.REACT_APP_CHATBOT_API_HOST ||
  `${window.location.protocol}//${window.location.host}`;

const axios: ChatbotAxios = baseAxios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: (params) => qs.stringify(params),
});

axios.setToken = (token: string) => {
  if (token) {
    axios.defaults.headers['Authorization'] = `Bearer ${token}`;
  }
};

const { get, post, put } = axios;
export { get, post, put, axios };
